















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { TaxCertificatePeriod } from '@tax-certificates/interfaces/tax-certificate-period';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { taxCertificatePeriodFields } from '@/config/tax_certificates';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import { Enrollment } from '@activities/interfaces/enrollment';

@Component({
  name: 'bc-tax-certificate-period-item-form',
  components: {
    'bpc-entity-select': EntitySelect,
    'bpc-input': Input,
    'bpc-datepicker': Datepicker,
    'bpc-input-group': InputGroup,
  },
})
export default class TaxCertificatePeriodItemForm extends Vue {
  declare $refs: {
    enrollmentSelect: InstanceType<typeof EntitySelect> & {
      getEntities(): void;
      items: any[];
    };
  };
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Number, default: 0 }) readonly index: number;
  @Prop({ type: Number, default: null }) readonly contactId: number;
  @Prop({ type: Number, default: null }) readonly taxCertificateId: number;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly errorsObject: object;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly period: TaxCertificatePeriod;

  formModel: TaxCertificatePeriod = {
    id: null,
    center_id: this.tenantId,
    tax_certificate_id: this.taxCertificateId,
    enrollment_id: null,
    start_date: null,
    end_date: null,
    num_days: null,
    price_per_day: null,
    paid_amount: null,
  };

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get isDisabled(): boolean {
    return this.disabled;
  }

  get fieldsConfig() {
    return taxCertificatePeriodFields;
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }

  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 px-2': true,
        },
      },
    };
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 px-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 px-2': true,
        },
      },
    };
  }

  get certificateContactId() {
    return this.contactId;
  }

  onChangeEnrollment(value: number) {
    if (value) {
      const enrollment: Enrollment = this.$refs.enrollmentSelect.items.find(
        (item: Enrollment) => item.id === value,
      );
      this.formModel.start_date = enrollment?.period_start_date;
      this.formModel.end_date = enrollment?.period_end_date;
      this.formModel.num_days = enrollment?.attendance_days;
      this.formModel.price_per_day = enrollment?.price_per_day;
      this.formModel.paid_amount = enrollment?.product_paid_amount;
    } else {
      this.resetFormModel();
    }
    this.$emit('period-changed', { index: this.index, value: this.formModel });
  }

  onEnrollmentsLoaded() {
    // If it is a creation with a default enrollment_id we set by default the values
    if (!this.formModel.id && this.formModel.enrollment_id) {
      this.onChangeEnrollment(this.formModel.enrollment_id);
    }
  }

  resetFormModel() {
    this.formModel = {
      id: null,
      center_id: this.tenantId,
      tax_certificate_id: this.taxCertificateId,
      enrollment_id: null,
      start_date: null,
      end_date: null,
      num_days: null,
      price_per_day: null,
      paid_amount: null,
    };
  }

  created() {
    this.formModel = { ...this.period };
  }

  @Watch('certificateContactId')
  async onChangeContactId() {
    this.resetFormModel();
    await this.$nextTick();
    this.$refs?.enrollmentSelect.getEntities();
  }
}
